import { render, staticRenderFns } from "./EditCustomerLoader.vue?vue&type=template&id=8460a1b8"
import script from "./EditCustomerLoader.vue?vue&type=script&lang=ts"
export * from "./EditCustomerLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports